const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Parital*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static has-text-right"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
